/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import edit from './edit';
var metadata = {
  name: "core/missing",
  category: "common",
  attributes: {
    originalName: {
      type: "string"
    },
    originalUndelimitedContent: {
      type: "string"
    },
    originalContent: {
      type: "string",
      source: "html"
    }
  }
};
import save from './save';
var name = metadata.name;
export { metadata, name };
export var settings = {
  name: name,
  title: __('Unrecognized Block'),
  description: __('Your site doesn’t include support for this block.'),
  supports: {
    className: false,
    customClassName: false,
    inserter: false,
    html: false,
    reusable: false
  },
  edit: edit,
  save: save
};
//# sourceMappingURL=index.js.map